import LawFirmFunding from './LawFirmFunding'

export default LawFirmFunding
